(function () {
  const noticeId = 'GiftWithPurchaseNotice';
  let noticeTimer;

  function getNotice() {
    let notice = document.getElementById(noticeId);
    if (notice) return notice;

    notice = document.createElement('div');
    notice.id = noticeId;
    notice.className = 'gift-with-purchase-notice';
    notice.setAttribute('role', 'status');
    notice.setAttribute('aria-live', 'polite');
    notice.setAttribute('aria-atomic', 'true');
    notice.hidden = true;
    document.body.appendChild(notice);
    return notice;
  }

  function notifyGiftUnavailable() {
    const notice = getNotice();
    notice.textContent = theme.strings.giftUnavailable;
    notice.hidden = false;
    window.clearTimeout(noticeTimer);
    noticeTimer = window.setTimeout(() => {
      notice.hidden = true;
    }, 6000);
  }

  function addedItems(response) {
    if (Array.isArray(response.items)) return response.items;
    return response && response.id ? [response] : [];
  }

  function findPrimaryItem(response, variantId) {
    const items = addedItems(response);
    return items.find((item) => String(item.variant_id || item.id) === String(variantId)) || items[0] || response;
  }

  async function parseResponse(response) {
    const state = await response.json();
    return {
      ok: response.ok && !state.status,
      state
    };
  }

  async function addGift(options) {
    const fallbackResponse = options.fallbackResponse || null;
    const giftVariantId = String(options.giftVariantId || '');
    const quantity = Number.parseInt(options.quantity, 10) || 0;

    if (!giftVariantId || quantity <= 0) {
      return {
        response: fallbackResponse,
        giftAdded: false,
        giftError: null
      };
    }

    if (options.giftAvailable === false) {
      notifyGiftUnavailable();
      return {
        response: fallbackResponse,
        giftAdded: false,
        giftError: 'unavailable'
      };
    }

    const payload = {
      items: [{
        id: Number(giftVariantId),
        quantity,
        properties: {
          _auto_gift: 'true',
          _gift_for_variant: String(options.primaryVariantId)
        }
      }]
    };

    if (options.sections && options.sections.length) {
      payload.sections = options.sections;
      payload.sections_url = options.sectionsUrl || window.location.pathname;
    }

    try {
      const giftResult = await parseResponse(await fetch(theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      }));

      if (!giftResult.ok) {
        notifyGiftUnavailable();
        return {
          response: fallbackResponse,
          giftAdded: false,
          giftError: giftResult.state
        };
      }

      return {
        response: giftResult.state,
        giftAdded: true,
        giftError: null
      };
    } catch (error) {
      notifyGiftUnavailable();
      return {
        response: fallbackResponse,
        giftAdded: false,
        giftError: error
      };
    }
  }

  async function add(options) {
    const primaryResult = await parseResponse(await options.addPrimary());
    const primaryResponse = primaryResult.state;
    const primaryItem = findPrimaryItem(primaryResponse, options.primaryVariantId);
    const giftVariantId = String(options.giftVariantId || '');

    if (!primaryResult.ok || !giftVariantId) {
      return {
        response: primaryResponse,
        primaryResponse,
        primaryItem,
        giftAdded: false,
        giftError: null
      };
    }

    const giftResult = await addGift({
      primaryVariantId: options.primaryVariantId,
      quantity: Math.max(1, Number.parseInt(options.quantity, 10) || 1),
      giftVariantId,
      giftAvailable: options.giftAvailable,
      sections: options.sections,
      sectionsUrl: options.sectionsUrl,
      fallbackResponse: primaryResponse
    });

    return {
      response: giftResult.response,
      primaryResponse,
      primaryItem,
      giftAdded: giftResult.giftAdded,
      giftError: giftResult.giftError
    };
  }

  window.GiftWithPurchase = {
    add,
    addGift,
    notifyGiftUnavailable
  };
})();
